import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UiService } from '../../services/ui.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { App_Routes } from '../../enums/router.enum';
import { LP_UI_CONFIG } from '../../core/tokens';

@Component({
  selector: 'app-asset-nav-button',
  templateUrl: './asset-nav-button.html',
  styleUrls: ['./asset-nav-button.scss'],
  imports: [NzIconModule],
})
export class AssetNavButtonComponent {
  fa_icon = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  show_icon = input<boolean>(true);
  svg_icon = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  svg_icon_right = input<string>('icons:arrow-right');
  asset = input<any | null>(null);
  sensorID = input<any | null>(null);
  working = input<boolean>(false);
  blackBG = input<any>(false);
  blackBorder = input<boolean>(false);
  blackCoral = input<boolean>(false);
  disabled = input<boolean>(false);
  amount = input<string | number>(GLOBAL_CONSTANT.EMPTY_STRING);
  greyOut = input<boolean>(false);
  bypassConnectedStatus = input<boolean>(false);
  inactiveStatus = input<boolean>(false);
  warningStatus = input<boolean>(false);
  criticalStatus = input<boolean>(false);

  clickEvent = output<void>();

  public cfg = inject(LP_UI_CONFIG);
  private readonly router = inject(Router);
  private readonly ui = inject(UiService);

  // ===== Local reactive tick to rerender on orientation changes =====
  private orientationTick = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);

  private orientationEffect = effect(() => {
    // subscribe once; effect will set orientationTick when UiService emits
    const orientationChange = this.ui.OrientaionChange();
    if (orientationChange) {
      this.orientationTick.update((n) => n + 1);
    }
  });

  SensorID = computed(() => (this.sensorID() ? this.sensorID() : -1));

  connected = computed(
    () => this.bypassConnectedStatus() || (!!this.asset() && this.asset()!.isConnected)
  );

  warning = computed(() => (this.asset() ? this.asset()!.warning : this.warningStatus()));

  critical = computed(() => (this.asset() ? this.asset()!.critical : this.criticalStatus()));

  inActive = computed(() => (this.asset() ? this.asset()!.inactive : this.inactiveStatus()));

  isArchived = computed(() => (this.asset() ? this.asset()!.isArchived : false));

  // ===== Handlers =====
  onClick(event: Event) {
    event.stopPropagation();
    if (
      this.cfg.appName === 'em' &&
      !!this.asset() &&
      !this.connected() &&
      !this.bypassConnectedStatus()
    ) {
      return;
    }
    if (!this.disabled()) {
      this.clickEvent.emit();

      // ensure overlay closes before navigation (preserves original behavior)
      setTimeout(() => {
        const a = this.asset();
        if (a) {
          if (this.cfg.appName === 'ia') {
            this.router.navigate([App_Routes.ASSET, a.objectID]);
          } else {
            this.router.navigate([App_Routes.ASSET, a.objectID, this.SensorID()]);
          }
        }
      });
    }
  }
}
